<template>
  <div class="home-container">
    <img src="../../assets/images/nine-year/bg.png" class="bg" alt="" />
    <div class="activity-btn">
      <!-- <a href="https://wx.bosch-extra.com.cn/#/goodsGifts"> -->
      <img
        src="../../assets/images/nine-year/part1.png"
        class="bg-img"
        alt=""
        @click="goGoodsGifts()"
      />
      <!-- </a> -->
      <img
        src="../../assets/images/nine-year/part3.png"
        class="bg-img"
        @click="navigateTo('/activity/ninth-year-part3')"
        alt=""
      />
    </div>

    <div class="activity-info">
      <div class="info-text">
        <div class="info-title">活动说明</div>
        <div class="info-detail">
          <div>1.</div>
          活动期间下单可随机获得奖励，每日仅限一次；
        </div>
        <div class="info-detail">
          <div>2.</div>
          实物奖励随订单一起发货，满减券和积分红包将于订单确认之后到账；
        </div>
        <div class="info-detail">
          <div>3.</div>
          本活动仅针对易加修理厂用户；
        </div>
        <div class="info-detail">
          <div>4.</div>
          本活动最终解释权归博世易加网所有，如有疑问请咨询客服。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
export default {
  methods: {
    navigateTo (url) {
      this.$router.push(url)
    },
    goGoodsGifts () {
      window.location.href = commonUtils.getExtraSite() + '/#/goodsGifts'
    }
  }
}
</script>

<style scoped>
.home-container {
  width: 100vw;
}
.bg {
  width: 100vw;
  position: absolute;
}
.activity-btn {
  background-color: rgba(240, 248, 255, 0);
  margin: 0 5vw;
  position: relative;
  top: 171px;
}
.bg-img {
  width: 100%;
  margin-bottom: 5px;
}
.activity-info {
  position: relative;
  top: 173px;
  height: 250px;
  margin: 0 4vw;
  background-image: url("../../assets/images/nine-year/activity-info-bg.png");
  background-size: 100%;
  color: rgb(216, 216, 216);
}
.info-text {
  margin: 22px;
}
.info-title {
  padding: 20px 0 20px 0;
  font-size: 20px;
  text-align: center;
  font-weight: bold;
}
.info-detail {
  padding-bottom: 10px;
  line-height: 20px;
  display: flex;
}
</style>
